import React, { Component } from "react";
import { Redirect } from "react-router";
import { Row, Col, FormGroup, Label, Button } from "reactstrap";
import { api, validationHelper } from "../helpers";
import Alert from "react-s-alert";

export class Bootstrap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            redirectToLogin: false
        };

        this.bootstrap = this.bootstrap.bind(this);
    }

    bootstrap() {
        if (
            !validationHelper.validate([
                this.state.firstName,
                this.state.lastName,
                this.state.email,
                this.state.password
            ])
        ) {
            Alert.error("All form fields are required");
            return;
        }

        const data = {
            FirstName: this.state.firstName,
            LastName: this.state.lastName,
            Email: this.state.email,
            Password: this.state.password
        };
        const errorMessage = "There was an error bootstrapping the system";
        api
            .post("bootstrap", data)
            .then(response => {
                if (response) {
                    Alert.success("System has been bootstrapped successfully");
                    this.setState({
                        redirectToLogin: true
                    });
                } else {
                    Alert.error(errorMessage);
                }
            })
            .catch(() => Alert.error(errorMessage));
    }

    render() {
        if (this.state.redirectToLogin) {
            return <Redirect to="/login" />;
        }
        return (
            <div>
            <Row>
            <Col xs={3}>
            <FormGroup>
            <Label>First Name:</Label>
        <input
        maxLength="30"
        className="form-control"
        value={this.state.firstName}
        onChange={e => this.setState({ firstName: e.target.value })}
        />
        </FormGroup>
        </Col>
        </Row>
        <Row>
        <Col xs={3}>
            <FormGroup>
            <Label>Last Name:</Label>
        <input
        maxLength="30"
        className="form-control"
        value={this.state.lastName}
        onChange={e => this.setState({ lastName: e.target.value })}
        />
        </FormGroup>
        </Col>
        </Row>
        <Row>
        <Col xs={3}>
            <FormGroup>
            <Label>Email:</Label>
        <input
        maxLength="50"
        className="form-control"
        value={this.state.email}
        onChange={e => this.setState({ email: e.target.value })}
        />
        </FormGroup>
        </Col>
        </Row>
        <Row>
        <Col xs={3}>
            <FormGroup>
            <Label>Password:</Label>
        <input
        type="password"
        className="form-control"
        value={this.state.password}
        onChange={e => this.setState({ password: e.target.value })}
        />
        </FormGroup>
        </Col>
        </Row>
        <Row>
        <Col xs={3}>
            <Button
        color="primary"
        onClick={() => {
            this.bootstrap();
        }}
    >
        Bootstrap System
        </Button>
        </Col>
        </Row>
        </div>
    );
    }
}


// WEBPACK FOOTER //
// ./src/components/Bootstrap.js